import { atom } from "jotai";
import { AccessType } from "shared/models";

/**
 * Primitives
 */

/**
 * Atom to store the authentication token retrieved from the Keycloak.
 * This token should be sent whenever a request is made to fetch data from the backend
 */
export const authTokenAtom = atom<string>("");
// Atom to track the current user's highest access type
export const highestAccessTypeAtom = atom<AccessType>(AccessType.viewer);
export const canLoadAppAtom = atom<boolean>(false);

authTokenAtom.debugLabel = "AUTH_TOKEN";
